import { render, staticRenderFns } from "./pElectronic.vue?vue&type=template&id=3bae41c0"
import script from "./pElectronic.vue?vue&type=script&lang=js"
export * from "./pElectronic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports